import React from "react";
import { useIntl } from "react-intl";
import { roles } from "../../../..";
import { DeleleteLayout } from "../../../../app/modules/common/DeleteLayout";
import { AERole } from "../../../../_emywork/components/AERole";
import { AEButton } from "../../../../_emywork/components/buttons";
import { AEMoment } from "../../../../_emywork/components/moment";
import { getConfig } from "../../../i18n";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  LoadingDialog,
  Pagination,
} from "../../../_partials/controls";
export const filterColumnsByRole = (column) => {
  const { role } = getConfig();

  if (!column.acceptedRoles) return true;

  return column.acceptedRoles.includes(role);
};
const TableLayout = ({
  Filter,

  cardTitle,
  columns = [],
  metadata = {},
  entities = [],
  acceptedRoles = [roles.client, roles.provider, roles.super_admin],
  isLoading,
  CONTEXT = "",
  CONTEXT_TITLE = "",

  getEntities = null,
  resource = null, //resource to edit (deposits,transactions...)
  useModuleContext,
  actionTypes,
  deleteModalTitle = "",
  actions,
  editable = true,
  deletable = true,
}) => {
  const { formatMessage } = useIntl();
  const {
    sortAsc,

    sortField,

    setSort,
  } = metadata;

  const {
    value: { openEditPage, openDeleteDialog },
  } = useModuleContext();

  return (
    <>
      <LoadingDialog
        isLoading={isLoading}
        text={formatMessage({ id: "LOADING" })}
      />
      <Filter {...metadata} />
      <Card>
        {/* <CardHeader title={formatMessage({ id: cardTitle })}>
          <CardHeaderToolbar>{<Filter {...metadata} />}</CardHeaderToolbar>
        </CardHeader> */}
        <CardBody className={"px-5"}>
          <div className="table-responsive gutter-b">
            <table className="table table-head-custom table-vertical-center table-head-bg table-borderless">
              <thead>
                <tr className="text-left">
                  {columns.filter(filterColumnsByRole).map((c, index) => {
                    const isSame = sortField === c.name;
                    return (
                      <th key={index} className="text-nowrap">
                        <AEButton
                          variant={isSame ? "link-primary" : null}
                          className="p-0 space"
                          onClick={() => {
                            if (c.sortable) setSort(c.name, !sortAsc);
                          }}
                          fontWeight={"bolder"}
                          key={index}
                        >
                          {formatMessage({ id: c.title })}
                          {c.sortable && isSame && (
                            <i
                              className={`flaticon2-arrow-${
                                sortAsc ? "down" : "up"
                              } icon-sm pl-3`}
                            />
                          )}
                        </AEButton>
                      </th>
                    );
                  })}
                  <th />
                </tr>
              </thead>
              <tbody>
                {entities &&
                  entities.map((r) => {
                    return (
                      <tr key={r.id} className="border-bottom rounded">
                        {columns.filter(filterColumnsByRole).map((c, index) => {
                          let label = c.template ? c.template(r) : r[c.name];

                          switch (c.type) {
                            case "date":
                              label = (
                                <AEMoment date={r[c.name]} format={"L"} />
                              );
                              break;
                            case "coins":
                              label =
                                new Intl.NumberFormat("fr-FR").format(
                                  r[c.name]
                                ) + " Coins";
                              break;
                            default:
                              break;
                          }
                          return <td key={index}> {label} </td>;
                        })}
                        <td className={"d-flex"}>
                          {
                            <AERole accept={acceptedRoles}>
                              <>
                                {editable && (
                                  <AEButton
                                    variant={"light"}
                                    size={"sm"}
                                    className={"mr-1"}
                                    onClick={(e) => {
                                      openEditPage(r.id, resource, r);
                                    }}
                                  >
                                    {formatMessage({ id: "EDIT" })}
                                  </AEButton>
                                )}

                                {deletable && (
                                  <AEButton
                                    variant={"light"}
                                    size={"sm"}
                                    onClick={(e) => {
                                      // setOnDelete({
                                      //   ...onDelete,
                                      //   getEntities: getEntities,
                                      // });
                                      openDeleteDialog(r.id);
                                    }}
                                  >
                                    {" "}
                                    {formatMessage({ id: "DELETE" })}{" "}
                                  </AEButton>
                                )}
                              </>
                            </AERole>
                          }
                        </td>
                      </tr>
                    );
                  })}
                {!isLoading && entities.length === 0 && (
                  <tr className={"text-center"}>
                    <td
                      colSpan={columns.length + 1}
                      className="font-weight-bolder"
                    >
                      {" "}
                      {formatMessage({ id: "LIST.EMPTY" })}{" "}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {!!Object.keys(metadata).length && (
            <Pagination {...metadata} className={""} />
          )}{" "}
        </CardBody>
      </Card>
      <DeleleteLayout
        useModuleContext={useModuleContext}
        CONTEXT={CONTEXT}
        CONTEXT_TITLE={CONTEXT_TITLE}
        metadata={metadata}
        actionTypes={actionTypes}
        deleteModalTitle={deleteModalTitle}
        actions={actions}
      />
    </>
  );
};

export default TableLayout;
